import { useEffect, useState } from "react"
import { Accordion, TableCustom } from "../../../../components/common"
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { useEntidad } from "../../../../components/hooks/useEntidad"
import AddFiltroModal from "./components/AddFiltroModal"
import { useMemo } from "react"

const Filtros = ({ idTipoTributo, params, data, setData, setPendingChange }) => {
    const [addingFiltro, setAddingFiltro] = useState(false)

    const [getEntidades, getRowEntidad, readyEntidad] = useEntidad({
        entidades: ['Filtro'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
          key: 'Filtro',
          timeout: 0
        }
    });

    const availableFiltros = useMemo(() => {
        if (!readyEntidad)
            return []
        else return getEntidades('Filtro').filter(x => (
            [idTipoTributo, 0, null].includes(x.idTipoTributo)
            && !data.some(y => x.id === y.idFiltro && y.state !== 'r')
        ))
    }, [data, readyEntidad])

    const tableData = useMemo(() => {
        if (!readyEntidad)
            return []
        else return data.filter(item => item.state !== 'r').map(item => ({
            id: item.id,
            nombre: getRowEntidad('Filtro', item.idFiltro).nombre,
            state: item.state,
        }))
    }, [data, readyEntidad])

    const onAdd = () => {
        setAddingFiltro(true)
    }

    const onRemove = ({ id }) => {
        const newData = [...data]
        for (let i = 0; i < newData.length; i++) {
            if (newData[i].id === id) {
                if (newData[i].state === 'o')
                    newData[i].state = 'r'
                else {
                    newData.splice(i, 1)
                }
                break
            }
        }
        setData(newData)
        setPendingChange(true)
    }

    const onAddConfirm = (selected) => {
        const newData = [...data]
        selected.forEach((item, index) => {
            let found = false
            for (let i = 0; i < newData.length; i++) {
                if (newData[i].idFiltro === item.id) {
                    newData[i].state = 'o'
                    found = true
                    break
                }
            }
            if (!found) newData.push({
                id: new Date() + index,
                idFiltro: item.id,
                idProcedimiento: parseInt(params.id),
                state: 'a',
            })
        })
        setData(newData)
        setPendingChange(true)
        setAddingFiltro(false)
    }

    return <>
        <Accordion title="Filtros" className="m-top-20">
            <TableCustom
                className='TableCustomBase'
                avmr={{ onAdd, onRemove, }}
                data={tableData}
                columns={[
                    { Header: 'Nombre', accessor: 'nombre', width: '95%', },
                ]}
                showFilterGlobal={false}
                showDownloadCSV={false}
            />
        </Accordion>
        {addingFiltro && (
            <AddFiltroModal
                filtros={availableFiltros}
                onConfirm={onAddConfirm}
                onCancel={() => setAddingFiltro(false)}
            />
        )}
    </>
}

export default Filtros
